import { render, staticRenderFns } from "./indexUser.vue?vue&type=template&id=a6324488"
import script from "./indexUser.vue?vue&type=script&lang=js"
export * from "./indexUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports